import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Http } from "../../../../helpers/axois";

interface IProps {
    appDetails: any
}

export const DmnDeployModal = (props: IProps) => {
    const appId = props.appDetails && props.appDetails.appId;
    const [dmnKeys, setDmnKeys]: any = useState([])

    useEffect(() => {
        getDmnKeys()
    }, [])

    const getDmnKeys = () => {
        Http.get(`/apps/${appId}/dmn?versionId=${props.appDetails.version_id}&dmnKeys=true`).subscribe((res: any) => {
            const key = res?.map((key: any) => {
                if (key?.dmnKeys) {
                    return key.dmnKeys
                }
            }).filter((e: any) => { return e }).flat()
            setDmnKeys(key)
        })
    }


    return (
        <div style={{ padding: 10 }}>
            <div style={{
                color: "#787C8D",
                fontSize: 14
            }}
            >Following DMNs will be deployed. Please confirm and deploy
            </div>
            <div style={{ marginTop: 5, height: 150, overflowX: "auto" }}>
                {dmnKeys.map((key: any, index: any) => {
                    return (
                        <div style={{
                            maxHeight: 35,
                            padding: 5,
                            background: index % 2 === 0 ? "#D7D9E524" : "#FFFFFF"
                        }}>
                            <p style={{
                                fontSize: 14,
                                paddingLeft: 5,
                                marginBottom: 0,
                                color: "#000000"
                            }}>{key}</p>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}